<template>
    <div class="row">
        <div class="col-sm-12 col-xl-6">
            <!-- File Upload and Control Section -->
            <div class="form-card h-100 p-4">
                <div class="mb-3">
                    <label for="formFile" class="form-label">Upload File</label>
                    <input class="form-control" type="file" id="formFile" @change="handleFileUpload" />
                </div>
                <button type="submit" class="btn btn-primary" @click="uploadFile">Upload</button>
                <button type="button" class="btn btn-success m-2" @click="importData" :disabled="!dataRead">Import</button>
                <a class="btn btn-warning m-2" v-if="resultsAvailable" :href="resultsUrl" download>Download Results</a>
            </div>
        </div>
    </div>
</template>

<script lang="ts">

import { fetchWrapper } from "@/helpers";

export default {
    name: "import-dividend",
    data() {
        return {
        file: null,
        fileUploaded: false,
        dataRead: true,
        resultsAvailable: false,
        resultsUrl: "",
        };
    },
    methods: {
        // Capture file from the input change event
        handleFileUpload(event) {
            // Check if files are available in the event target
            if (event.target.files && event.target.files.length > 0) {
                this.file = event.target.files[0];
            } else {
                console.error('No file selected');
                this.file = null;
            }
        },
        async uploadFile() {
            if (!this.file) {
                alert("Please select a file first.");
                return;
            }

            // Create a FormData object to hold the file
            const formData = await new FormData();

            await formData.append('file', this.file); // 'file' should match the field expected by your API
            try {
                // Perform the file upload request
                await fetchWrapper.post('api/dividend/import-new-dividend-file', formData);
                this.dataRead = true; // Enable the Read button after successful upload
            } catch (error) {
                console.error("Error uploading file:", error);
            }
        },
        async importData() {
            try {
                // fetchWrapper already parses the JSON response body.
                await fetchWrapper.post('api/dividend/import-new-dividend');

                this.resultsAvailable = true; // Enable the Read button after successful import
                this.resultsUrl = `${fetchWrapper.url}results`; // Set the URL for results
            } catch (error) {
                console.error("Error importing data:", error);
            }
        },
    }
}
</script>

<style scoped>
.form-card {
  background: #fff;
  border: 1px solid var(--border);
  border-radius: 12px;
}
</style>